import { HeartOutlineIcon } from './HeartOutlineIcon';

/**
 * author: Google
 * id 9BCD22D2-7304-4BB3-9C41-3431ED13542A
 * name heart-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/heart-outline.svg
 * tags
 * - Shape 
 * - Gaming / RPG 
 * - Medical / Hospital 
 */
export const FavoriteOutlineIcon = HeartOutlineIcon;
export default FavoriteOutlineIcon